





















































import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment'
import Commit from '@/components/comment/index.vue'
import ThumbsUp from '@/components/ThumbsUp/index.vue'
import ReadList from '@/components/ReadList/index.vue'
import Share from '@/components/Share/index.vue'
import { getYearPlanDetailById } from '@/api/year'
@Component({
  components: {
    Commit,
    ThumbsUp,
    Share,
    ReadList
  },
})
export default class YearDetail extends Vue {
  @Prop({ type: String, default: '', required: true })
  planId!: string
  @Prop({ type: String, default: '', required: true })
  year!: string
   @Prop({ type: String, default: '', required: true })
  commentId!: string
  fileList: Object[] = [
    {
      name: '1.jpg',
    },
  ]
  PlanDetailData: any = {}
  dataLoading: boolean = true
  moment = moment

  mounted() {
    this.getPlanDetail()
  }
  async getPlanDetail() {
    const [err, data] = await getYearPlanDetailById(this.planId, {commentId: this.commentId})
    if (err) {
      this.dataLoading = false
      return
    }
    if (data) {
      this.PlanDetailData = data
      if (data.businessAttachmentList === null) {
        this.PlanDetailData.businessAttachmentList = []
      }
      this.dataLoading = false
    }
  }
  get userName() {
    return this.$store.state.user.name
  }
}
